module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_fixation-d4aab361b29ef0de5d5ff8f0e35d6326.svg";